const state = {
    padCount: 0,
    nspCount: 0,
    dacCount: 0
}

const mutations = {
    SET_PAD_COUNT(state, value) {
        state.padCount = value
    },

    SET_NSP_COUNT(state, value) {
        state.nspCount = value
    },

    SET_DAC_COUNT(state, value) {
        state.dacCount = value
    },
}

export default {
    namespaced: true,
    state,
    mutations
}
